@layer tbw-plugins {
  .tbw-tooltip-popover {
    /* Reset browser popover defaults — overflow:visible set inline for UA specificity */
    margin: 0;
    padding: var(--tbw-tooltip-padding, var(--tbw-spacing-sm, 0.375rem) var(--tbw-spacing-md, 0.5rem));
    background: var(--tbw-tooltip-bg, light-dark(#333338, #484850));
    color: var(--tbw-tooltip-fg, light-dark(#f5f5f5, #f0f0f0));
    border: 1px solid var(--tbw-tooltip-border, light-dark(#222226, #6a6a72));
    border-radius: var(--tbw-tooltip-radius, var(--tbw-border-radius, 0.25rem));
    box-shadow: none;
    filter: var(--tbw-tooltip-shadow, drop-shadow(0 4px 4px rgba(0, 0, 0, 0.45)));
    font-family: var(--tbw-font-family, system-ui, sans-serif);
    font-size: var(--tbw-tooltip-font-size, var(--tbw-font-size-sm, 0.9285em));
    max-width: var(--tbw-tooltip-max-width, 300px);
    white-space: pre-wrap;
    word-wrap: break-word;
    overflow-wrap: break-word;
    /* WCAG 2.2 SC 1.4.13 "Hoverable": the pointer must be able to rest on the
       tooltip without dismissing it, so long or truncated content can be read,
       magnified, and selected. The plugin's grace-period hide covers the gap
       between the cell and the popover. */
    pointer-events: auto;
    user-select: text;
    z-index: 10001;
  }

  /* Multi-line content (text contains `\n`): preserve author line breaks
     verbatim and let the popover grow horizontally instead of wrapping
     mid-line. `max-width` is lifted so long lines aren't broken. */
  .tbw-tooltip-popover.tbw-tooltip-multiline {
    white-space: pre;
    max-width: none;
    word-wrap: normal;
    overflow-wrap: normal;
  }

  /* Arrow — a 14×14 box rotated 45° to form a diamond, with its center
     pinned to the popover edge. Without `clip-path` the diamond's inner
     half sits *inside* the popover, painting `background: inherit` over
     the first ~7px of text content. The clip-path keeps only the
     pre-rotation triangle whose three corners rotate to the outside of
     the popover (the visible "V"), so the inner half is removed before
     it can overlap the content. clip-path is applied in the element's
     own (pre-transform) coordinate space per the CSS Transforms spec,
     which is why the polygon is expressed in the unrotated square. */
  .tbw-tooltip-popover::after {
    content: '';
    position: absolute;
    width: var(--tbw-tooltip-arrow-size, 14px);
    height: var(--tbw-tooltip-arrow-size, 14px);
    left: var(--tbw-tooltip-arrow-offset, 16px);
    background: inherit;
    pointer-events: none;
  }

  /* Arrow below-anchor default: diamond points up from the top edge.
     Pre-rotation: top-left, top-right, bottom-left → after rotate(45deg)
     these become the top, right, and left points of the diamond, i.e.
     the upper "V" that pokes above the popover. The bottom-right corner
     (which would land inside the popover) is clipped away. */
  .tbw-tooltip-popover:not(.tbw-tooltip-above)::after {
    top: calc(var(--tbw-tooltip-arrow-size, 14px) / -2);
    transform: rotate(45deg);
    border-top: 1px solid var(--tbw-tooltip-border, light-dark(#222226, #6a6a72));
    border-left: 1px solid var(--tbw-tooltip-border, light-dark(#222226, #6a6a72));
    clip-path: polygon(0 0, 100% 0, 0 100%);
  }

  /* Above-anchor: diamond points down from the bottom edge. Mirror of
     the below-anchor clip — keep the corners (top-right, bottom-right,
     bottom-left) that rotate to the right, bottom, and left points of
     the diamond, i.e. the lower "Λ" that pokes below the popover. */
  .tbw-tooltip-popover.tbw-tooltip-above::after {
    bottom: calc(var(--tbw-tooltip-arrow-size, 14px) / -2);
    transform: rotate(45deg);
    border-bottom: 1px solid var(--tbw-tooltip-border, light-dark(#222226, #6a6a72));
    border-right: 1px solid var(--tbw-tooltip-border, light-dark(#222226, #6a6a72));
    clip-path: polygon(100% 0, 100% 100%, 0 100%);
  }

  /* CSS Anchor Positioning — modern browsers.
     Placement is chosen in JS (`#prefersAbove`) rather than by
     `position-try-fallbacks`: the browser's flip is invisible to script, so the
     arrow-direction class could disagree with where the popover was painted —
     most visibly when re-hovering while a previous tooltip is still open. */
  @supports (anchor-name: --test) {
    .tbw-tooltip-popover {
      position-anchor: --tbw-tooltip-anchor;
      top: calc(anchor(bottom) + 11px);
      bottom: auto;
      left: anchor(left);
    }

    .tbw-tooltip-popover.tbw-tooltip-above {
      top: auto;
      bottom: calc(anchor(top) + 11px);
    }
  }
}
